// import React, { useState } from "react";
// import { FaArrowLeft } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import PlotAreaCalculator from "../components/PlotAreaCalculator";
// import AncillaryFactorCalculator from "../components/AncillaryFactorCalculator";
// import styles from "../styles/BuiltUpAreaCalculator.module.css";
// import styles1 from "../styles/UlcPremium.module.css";

// const BuiltUpAreaCalculator = () => {
//   const navigate = useNavigate();
//   const [step, setStep] = useState(1);
//   const [converterType, setConverterType] = useState("Built-up Area Calculator");

//   const handleBack = () => navigate(-1);
//   const handleNext = () => setStep(2);
//   const handlePrev = () => setStep(1);

//   const handleDropdownChange = (e) => {
//     const selected = e.target.value;
//     setConverterType(selected);
//     const pathMap = {
//       "Area Convertor": "/area-convertor",
//       "Built-up Area Calculator": "/built-up-area-calculator",
//       "Development Charges": "/development-charges",
//       "Premium for Ancillary FSI": "/ancillary-fsi",
//       "⁠Premium for Premium FSI": "/premium-fsi",
//       "ULC Premium": "/ulc-premium",
//     };
//     if (pathMap[selected]) navigate(pathMap[selected]);
//   };

//   return (
//     <div className={styles1.UlcPremium_container}>
//       <div className={styles1.UlcPremium_header}>
//         <button className={styles1.UlcPremium_backButton} onClick={handleBack}>
//           <FaArrowLeft />
//         </button>
//         <h2 className={styles1.UlcPremium_title}>Conversion Calculator</h2>
//       </div>

//       <div className={styles1.UlcPremium_dropdownContainer}>
//         <select
//           value={converterType}
//           onChange={handleDropdownChange}
//           className={styles1.UlcPremium_mainDropdown}
//         >
//           <option>Area Convertor</option>
//           <option>Built-up Area Calculator</option>
//           <option>Development Charges</option>
//           <option>Premium for Ancillary FSI</option>
//           <option>⁠Premium for Premium FSI</option>
//           <option>ULC Premium</option>
//         </select>
//       </div>

//       {/* Form Sections */}
//       <div className={styles.builtUpArea_formContainer}>
//         {step === 1 && <PlotAreaCalculator onNext={handleNext} />}
//         {step === 2 && <AncillaryFactorCalculator onPrev={handlePrev} />}
//       </div>
//     </div>
//   );
// };

// export default BuiltUpAreaCalculator;





import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  ArrowLeft, 
  Layers, 
  ChevronRight, 
  CheckCircle2, 
  Circle,
  LayoutGrid,
  Info
} from "lucide-react";

// Components
import PlotAreaCalculator from "../components/PlotAreaCalculator";
import AncillaryFactorCalculator from "../components/AncillaryFactorCalculator";

const BuiltUpAreaCalculator = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [converterType, setConverterType] = useState("Built-up Area Calculator");

  const handleBack = () => navigate(-1);
  const handleNext = () => setStep(2);
  const handlePrev = () => setStep(1);

  const handleDropdownChange = (e) => {
    const selected = e.target.value;
    setConverterType(selected);
    const pathMap = {
      "Area Convertor": "/area-convertor",
      "Built-up Area Calculator": "/built-up-area-calculator",
      "Development Charges": "/development-charges",
      "Premium for Ancillary FSI": "/ancillary-fsi",
      "⁠Premium for Premium FSI": "/premium-fsi",
      "ULC Premium": "/ulc-premium",
    };
    if (pathMap[selected]) navigate(pathMap[selected]);
  };

  return (
    <div className="min-h-screen bg-slate-100 pb-20">
      {/* --- HEADER --- */}
      <div className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-3xl mx-auto px-4 h-16 flex items-center gap-4">
          <button onClick={handleBack} className="p-2.5 hover:bg-slate-100 rounded-xl transition-all text-slate-600">
            <ArrowLeft size={22} />
          </button>
          <h2 className="text-lg font-black text-slate-900 uppercase tracking-tight">TPH Calc</h2>
        </div>
      </div>

      <main className="max-w-2xl mx-auto px-4 mt-10">
        {/* --- TOOL NAVIGATOR --- */}
        <div className="relative mb-10">
          <Layers className="absolute left-4 top-1/2 -translate-y-1/2 text-orange-500 z-10" size={18} />
          <select
            value={converterType}
            onChange={handleDropdownChange}
            className="w-full bg-white border border-slate-300 rounded-2xl py-5 pl-12 pr-4 font-bold text-slate-800 appearance-none shadow-md focus:outline-none"
          >
            <option>Area Convertor</option>
            <option>Built-up Area Calculator</option>
            <option>Development Charges</option>
            <option>Premium for Ancillary FSI</option>
            <option>⁠Premium for Premium FSI</option>
            <option>ULC Premium</option>
          </select>
          <ChevronRight className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" size={18} />
        </div>

        {/* --- MAIN CARD --- */}
        <div className="bg-white rounded-[2.5rem] shadow-2xl shadow-slate-400/40 ring-1 ring-slate-200 overflow-hidden transition-all duration-500">
          <div className="p-8 bg-[#111827] text-white flex justify-between items-center">
            <div>
              <h3 className="text-xl font-black tracking-tight">Built-up Area</h3>
              <p className="text-xs text-slate-400 font-bold uppercase tracking-widest mt-1">UDCPR Area Analysis</p>
            </div>
            <div className="w-10 h-10 bg-orange-600 rounded-xl flex items-center justify-center shadow-lg shadow-orange-900/20">
              <LayoutGrid size={20} />
            </div>
          </div>

          {/* PROGRESS STEPPER */}
          <div className="bg-slate-50 px-8 py-4 border-b border-slate-100 flex items-center justify-between">
            <div className="flex items-center gap-3">
               {step === 1 ? (
                 <div className="flex items-center gap-2 text-orange-600">
                   <Circle size={18} strokeWidth={3} />
                   <span className="text-[10px] font-black uppercase tracking-widest">Step 1: Plot Details</span>
                 </div>
               ) : (
                 <div className="flex items-center gap-2 text-emerald-600">
                   <CheckCircle2 size={18} />
                   <span className="text-[10px] font-black uppercase tracking-widest">Plot Details Completed</span>
                 </div>
               )}
            </div>
            <div className="h-px bg-slate-200 flex-grow mx-4"></div>
            <div className={`flex items-center gap-2 ${step === 2 ? "text-orange-600" : "text-slate-300"}`}>
               <span className="text-[10px] font-black uppercase tracking-widest">Step 2: Factors</span>
               {step === 2 ? <Circle size={18} strokeWidth={3} /> : <Circle size={18} />}
            </div>
          </div>

          {/* FORM CONTENT */}
          <div className="p-8">
            <div className="bg-orange-50/50 p-4 rounded-xl border border-orange-100/50 mb-8">
               <p className="text-[11px] text-orange-700 font-black flex items-center gap-2 leading-relaxed">
                 <Info size={14} className="shrink-0" /> 
                 {step === 1 
                   ? "Enter your plot dimensions and setbacks to calculate the net available area." 
                   : "Adjust FSI factors and ancillary percentages to determine final Built-up Area."}
               </p>
            </div>

            <div className="min-h-[400px]">
              {step === 1 && <PlotAreaCalculator onNext={handleNext} />}
              {step === 2 && <AncillaryFactorCalculator onPrev={handlePrev} />}
            </div>
          </div>
        </div>

        <p className="text-center mt-8 text-slate-400 text-[10px] font-bold uppercase tracking-widest">
          PropIntel Intelligence Platform • Structured Land Risk System
        </p>
      </main>
    </div>
  );
};

export default BuiltUpAreaCalculator;